module.exports = __webpack_public_path__ + "static/media/contact-us.85aad31d.jpeg";